// removed by extract-text-webpack-plugin
module.exports = {"description":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-ManageRecipientAlertEmail-__style___1dV5x"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/ManageRecipientAlertEmail/style.css
// module id = 2283
// module chunks = 0